import ContractDocumentAPI from "../../../api/ContractDocumentAPI";

export default {
  async getContractsByLesseeId({commit}, counterpartyId) {
    return await new ContractDocumentAPI().getContractsByLesseeId(counterpartyId);
  },
  async getAllContracts({commit}) {
    return await new ContractDocumentAPI().getAllContractDocuments();
  }
}

